import React from "react";
import { useTranslation } from "react-i18next";

import "./styles.scss";

interface DemoBadgeProps {
  type?: "organization" | "facility";
}

export const DemoBadge: React.FunctionComponent<DemoBadgeProps> = ({
  type = "organization",
}) => {
  const { t } = useTranslation();

  return (
    <span
      className="demo-badge"
      title={t(`common.demoBadge.tooltip_${type}`)}
    >
      {t("common.demoBadge.label")}
    </span>
  );
};
